/** @deprecated This enum is deprecated. Instead use ProductGalleryStyleV2Type */

export enum ProductGalleryStyleType {
  PRODUCT_GALLERY_MODAL = 'PRODUCT_GALLERY_MODAL',
  DEFAULT = 'DEFAULT',
}

export enum SwipeEnum {
  LEFT = 'left',
  RIGHT = 'right',
}
